module.exports = __webpack_public_path__ + "static/media/desk_rings.52ba61b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/desk_rings.mp3
// module id = ZPwz
// module chunks = 74